import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const DropdownLabel = styled.span`
    font-size: 14px;
    line-height: 20px;
    color: ${Colors.Black.V50};
`;

export const dropdownContainer = css`
    height: 100%;
    padding: 0 12px;
`;

export const selectedContainer = css`
    background: #f7f8f9;
    border-radius: 6px;
`;
